import React from "react"
import { Link } from "gatsby"
import { Container, Breadcrumb, BreadcrumbItem } from "reactstrap"
import Layout from "./../components/layout"
import SEO from "./../components/seo"
import "../style/products.css"

function DbCopy() {
  return (
    <Layout>
      <SEO />
      <Breadcrumb className="breadCrumb">
        <BreadcrumbItem>
          <Link className="breadCrumbLinks" to="/">
            Home
          </Link>
        </BreadcrumbItem>
        <BreadcrumbItem>
          <Link className="breadCrumbLinks" to="/products">
            Products
          </Link>
        </BreadcrumbItem>
        <BreadcrumbItem active>Database Copy</BreadcrumbItem>
      </Breadcrumb>
      <Container>
        <h1>Database Copy</h1>
        <h4
          style={{
            textAlign: "center",
            backgroundColor: "#2780E3",
            color: "white",
          }}
        >
          A Sophisticated CA IDMS Database Copy with Export/Import/Update
          Toolkit
        </h4>
        <h2>Features</h2>
        <h4 style={{ marginTop: "10px" }}>Export</h4>
        <ul style={{ listStyleType: "square" }}>
          <li>
            User-specified parameter information to navigate a CA IDMS database
          </li>
          <li>
            Output can be used by the DEMI/DB Update & Import Facilities or a
            user-written program
          </li>
          <li>Easy cloning of databases</li>
          <li>
            Easy generation of subsets of production databases for development,
            testing and Q& A
          </li>
          <li>
            User Exit points to enhance the data selection and/or modify and
            edit the data
          </li>
          <li>
            Edit output using standard ISPF EDIT or other third party products
            such as FILE-AID®
          </li>
          <li>Optional data access paths also available</li>
        </ul>
        <h4 style={{ marginTop: "10px" }}>Import</h4>
        <ul style={{ listStyleType: "square" }}>
          <li>Optional data access paths also available</li>
          <li>
            Takes the file generated file from the EXPORT facility and reloads
            the target CA IDMS database
          </li>
          <li>
            Output can be used by the DEMI/DB Update & Import Facilities or a
            user-written program
          </li>
          <li>
            User-supplied parameter information to navigate a specified CA IDMS
            database to erase, connect and/or disconnect database records
          </li>
        </ul>
      </Container>
    </Layout>
  )
}

export default DbCopy
